<template>
  <div>
    <SampleSearchForm :listForm="searchList" @handlerSearch="onSearch" />
    <CommonTable
      ref="CommonTable"
      :loading="tableLoading"
      :tableHead="tableHeadTab"
      :tableData="tableDataTab"
      :tableParam="tableParamTab"
      :showCheckbox="false"
      @page-size-change="pageSizeChange"
    >
      <template #idSlot="{ row }">
        <div class="cml-sample-info-capacity">
          <el-image
            v-if="row.mainImage" 
            style="width: 50px; height: 50px; margin-right: 5px;"
            :src="row.mainImage + $ImgQuality30"
            :preview-src-list="[row.mainImage + $ImgPreviewQuality]"
            fit="contain"
          >
            <div slot="placeholder" class="sample-image-slot">
              加载中
            </div>
          </el-image>
          <div>
            <p>产品ID：{{ row.productId }} </p>
            <span>{{ row.productName }} </span>
            <div v-if="row.capacity">
              容量：{{ row.capacity }}{{ row.unit }}
            </div>
          </div>
        </div>
      </template>
      <!-- 查看详情 -->
      <template #codeSlot="{ row }">
        <span class="detail-text-class" @click="showDetail(row)">{{
          row.code
        }}</span>
      </template>
    </CommonTable>
    <!-- 详情弹窗 -->
    <SampleOperationLogDialog ref="sampleOperationLogDialog" :listData="listData" />
  </div>
</template>

<script>
import CommonTable from '@/components/CommonTable';
import SampleSearchForm from '@/components/SampleSearchForm';
import SampleOperationLogDialog from '@/components/SampleOperationLogDialog';
export default {
  components: { CommonTable, SampleSearchForm, SampleOperationLogDialog },
  props: {
    addBtn: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      searchList: {
        list: [
          {
            tag: 'el-input',
            label: '寻样单编号',
            prop: 'code',
            defaultValue: undefined,
            placeholder: '请输入完整寻样单编号',
          },
          {
            tag: 'el-input',
            label: '产品名称',
            prop: 'productName',
            defaultValue: undefined,
            placeholder: '请输入关键字',
          },
        ],
      },
      listForm: { statusList: ['RECEIPT', 'GET', 'DELETE', 'COMPLETE'] },
      tableLoading: false,
      tableParamTab: {
        pageNo: 1,
        pageSize: 20,
        orderBy: '',
      },
      tableHeadTab: [
        {
          label: '产品名称',
          prop: 'productName',
          slotColumn: true,
          slotName: 'idSlot',
          width: 200,
        },
        {
          label: '寻样单编号',
          prop: 'code',
          width: 140,
          slotColumn: true,
          slotName: 'codeSlot',
        },
        { label: '申请时间', prop: 'createDate', width: 140 },
        { label: '数量', prop: 'num', width: 80 },
        { label: '单位', prop: 'orderUnit', width: 80 },
        { label: '采购备注', prop: 'forSupplierRemark' },
        { label: '要求到样时间', prop: 'askArrivalTime', width: 140 },
        { label: '供应商', prop: 'supplierName' },
        { label: '供应商备注', prop: 'supplierRemark' },
        { label: '寄出时间', prop: 'deliveryDate', width: 140 },
        { label: '快递公司', prop: 'express' },
        { label: '快递单号', prop: 'expressNo' },
      ],
      tableDataTab: {},
      listData: {}
    };
  },
  mounted() {
    this.getList();
    this.$refs.CommonTable.changeHeight(-20);
  },
  methods: {
    // 查询
    onSearch(val) {
      this.tableParamTab.pageNo = 1;
      this.listForm = { ...this.listForm, ...val };
      this.getList();
    },
    // table数据
    getList() {
      const params = {
        ...this.tableParamTab,
        data: this.listForm,
      };
      this.tableLoading = true;
      this.$http.sample
        .getOrderDeliveryInfoOrderList(params)
        .then(result => {
          this.tableDataTab = result.data;
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    // 翻页
    pageSizeChange(pageNo, pageSize) {
      this.tableParamTab.pageNo = pageNo;
      this.tableParamTab.pageSize = pageSize;
      this.getList();
    },
    showDetail(row) {
      this.$refs.sampleOperationLogDialog.dialogVisible = true;
      this.listData = {
        supplierName: row.supplierName,
        list: [row],
      };
    }
  },
};
</script>